import React from 'react';
import { Link } from 'react-router-dom';
import Header from "../layout/Header";
import Footer from '../layout/Footer';
import Toolbar from '../navigation/Toobar';
import Chat from '../components/common/Chat';
import useSEO from '../hooks/useSEO';
import { buildBreadcrumbJsonLd, getSiteBrand } from '../utils/seo';

const TERMS_BREADCRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'Terms and Conditions', path: '/terms-and-conditions' },
];

function TermsAndConditions({ globalData }) {
  const brandName = globalData?.general?.site_title || getSiteBrand();

  useSEO({
    title: 'Terms and Conditions',
    description: `Read the ${brandName} terms and conditions: eligibility, account rules, deposits and withdrawals, bonus and turnover requirements, fair play, service availability and responsible gaming.`,
    keywords: `terms and conditions, betting rules bangladesh, account rules, bonus terms, withdrawal policy, fair play, responsible gaming`,
    path: '/terms-and-conditions',
    brand: brandName,
    jsonLd: [buildBreadcrumbJsonLd(TERMS_BREADCRUMBS)],
  });

  return (
    <div className="v-application--wrap">
      <div>
        <div className="row no-gutters">
          <Header />
        </div>

        <div className="body">
          <div className="page-container v-card v-sheet theme--dark">
            <div className="row">
              <div className="col col-12">
                <div className="pa-4">
                  <nav className="seo-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Home</Link> <span aria-hidden="true">›</span>{' '}
                    <span aria-current="page">Terms and Conditions</span>
                  </nav>

                  <h1 className="seo-h1">Terms and Conditions</h1>
                  <div className="mt-3">
                    <p className="mb-2">These Terms and Conditions apply to your use of {brandName}.</p>
                    <p className="mb-3">
                      By accessing or using our website and services, you confirm that you have
                      read, understood, and agree to be bound by these terms, along with any
                      additional rules shown inside the platform.
                    </p>

                    <h2 className="seo-h2">1) Eligibility</h2>
                    <div className="mt-2">
                      <p className="mb-2">
                        You must be legally allowed to use online gaming/entertainment services in
                        your jurisdiction. If you are under the required legal age, you must not use
                        the platform.
                      </p>
                      <p className="mb-0">
                        You are responsible for ensuring compliance with local laws and
                        regulations.
                      </p>
                    </div>

                    <h2 className="seo-h2">2) Account Rules</h2>
                    <div className="mt-2">
                      <ul className="mb-0">
                        <li>Create only one account per user unless permitted.</li>
                        <li>Keep your login details secure and do not share your account.</li>
                        <li>Provide accurate information and keep it updated.</li>
                        <li>
                          We may suspend or close accounts involved in abuse, fraud, or policy
                          violations.
                        </li>
                      </ul>
                    </div>

                    <h2 className="seo-h2">3) Deposits &amp; Withdrawals</h2>
                    <div className="mt-2">
                      <ul className="mb-0">
                        <li>Deposits must be made using approved payment methods.</li>
                        <li>
                          Withdrawals may require verification checks for security and compliance.
                        </li>
                        <li>
                          Processing times may vary depending on payment providers and
                          verification requirements.
                        </li>
                      </ul>
                    </div>

                    <h2 className="seo-h2">4) Bonuses &amp; Promotions</h2>
                    <div className="mt-2">
                      <p className="mb-2">
                        Promotions may have separate rules such as wagering/turnover requirements,
                        eligibility limits, and time restrictions.
                      </p>
                      <p className="mb-0">
                        If bonus abuse is detected, we may cancel bonuses and adjust related
                        winnings.
                      </p>
                    </div>

                    <h2 className="seo-h2">5) Responsible Gaming</h2>
                    <div className="mt-2">
                      <p className="mb-0">
                        Please play responsibly. If you feel gambling is becoming a problem, take a
                        break and seek help. We may offer account controls depending on the
                        platform configuration.
                      </p>
                    </div>

                    <h2 className="seo-h2">6) Service Availability</h2>
                    <div className="mt-2">
                      <p className="mb-0">
                        We may update, change, or temporarily suspend services for maintenance,
                        security, or operational reasons.
                      </p>
                    </div>

                    <h2 className="seo-h2">7) Limitation of Liability</h2>
                    <div className="mt-2">
                      <p className="mb-0">
                        To the fullest extent permitted by law, {brandName} is not liable for
                        indirect losses, network interruptions, or third-party service failures.
                      </p>
                    </div>

                    <h2 className="seo-h2">8) Changes to These Terms</h2>
                    <div className="mt-2">
                      <p className="mb-0">
                        We may update these terms at any time. Continued use of the platform after
                        changes means you accept the updated terms.
                      </p>
                    </div>

                    <h2 className="seo-h2">9) Contact</h2>
                    <div className="mt-2">
                      <p className="mb-0">
                        For questions about these Terms and Conditions, please use the Contact Us
                        page or the support channels linked in the footer.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer sociallink={globalData?.socialLinks || {}} />
          </div>

          <Toolbar />
          <Chat />
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
